import { useFormik, FormikProvider, Form, Field, ErrorMessage } from "formik";
import * as bie from "react-bootstrap";
import { ERROR_MSG } from "../CommonUtils/contextVariables";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet } from "../CommonUtils/CommonAxios";

// Hooks & Components
import { useRusaMasterData } from "./hooks/useRusaMasterData";
import { useRusaFormSubmit } from "./hooks/useRusaFormSubmit";
import {
  WorkDetailsSelect,
  OtherWorkInput,
  NoOfUnitsInput,
  ProgressSelect,
  StartDateInput,
  EndDateInput,
  PercentageCompletionInput,
  PresentStatusInput,
  GeoTaggedPhotoInput,
  FacilityInUseRadio,
  VideoLinkInput,
  deleteWithConfirm
} from "./components/RusaFormFields";
import { currentMonth, currentYear } from "../CommonUtils/CommonServices";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import { RiDeleteBin2Line } from "react-icons/ri";
import { FaEdit } from "react-icons/fa";
import { BsEyeFill } from "react-icons/bs";
import { viewImage } from "../CommonUtils/viewImage";

const Equipment = () => {
  const { worksList } = useRusaMasterData();
  const { submitForm } = useRusaFormSubmit();

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  // Local state for sub-works
  const [subWorksList, setSubWorksList] = useState([]);

  const GetSubWorksList = (subCompId) => {
    if (subCompId !== "3" && subCompId !== "6") {
      const url = `${config.url.API_URL}getRusaSubEquipWorksList?equipId=${subCompId}`;
      CommonAxiosGet(url)
        .then((res) => {
          if (res?.data?.status && res?.data?.scode === "01") {
            setSubWorksList(res.data.data || []);
          } else {
            setSubWorksList([]);
          }
        })
        .catch(console.error);
    }
  };
  // : Yup.string().required(ERROR_MSG).nullable(),
  const validationSchema = Yup.object({
    rusaPhase: Yup.string().required(ERROR_MSG).nullable(),
    compId: Yup.string().required(ERROR_MSG).nullable(),

    constructionType: Yup.string().required(ERROR_MSG).nullable(),
    otherWork: Yup.string().when("constructionType", {
      is: "99",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    noOfUnitsConstructed: Yup.string().required(ERROR_MSG).nullable(),
    progressOfWork: Yup.string().required(ERROR_MSG).nullable(),
    percentageOfCompletion: Yup.string().when("progressOfWork", {
      is: "ongoing",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    geoTaggedPhotos: Yup.string().when("progressOfWork", {
      is: (val) => val === "ongoing" || val === "completed",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),

    subEquipId: Yup.string().when("constructionType", {
      is: (val) => val === "1" || val === "2" || val === "4",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    presentStatus: Yup.string().when("progressOfWork", {
      is: "ongoing",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),

    subEquipmentOther: Yup.string().when("subEquipId", {
      is: "999",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),


    startDate: Yup.string().when("progressOfWork", {
      is: (val) => val === "ongoing" || val === "completed",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),

    dateOfCompletion: Yup.string().when("progressOfWork", {
      is: (val) => val === "ongoing" || val === "completed",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),


    videoLinks: Yup.string().when("progressOfWork", {
      is: "completed",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    briefDesc: Yup.string().when("progressOfWork", {
      is: "completed",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),
    wetherUsing: Yup.string().when("progressOfWork", {
      is: "completed",
      then: (schema) => schema.required(ERROR_MSG),
      otherwise: (schema) => schema.notRequired(),
    }),

  });

  const valueOrNull = (v) =>
    v !== "" && v !== undefined && v !== null ? v : null;

  const formik = useFormik({
    initialValues: {
      rusaPhase: "",
      constructionType: "",
      noOfUnitsConstructed: "",
      progressOfWork: "",
      subEquipId: "",
      equipmentOtherText: "",
      otherWork: "",
      startDate: "",
      dateOfCompletion: "",
      percentageOfCompletion: "",
      presentStatus: "",
      constructionPhoto: "",
      compId: "",
      wetherUsing: "",
      briefDesc: "",
      geoTaggedPhotos: "",
      videoLinks: "",
      subEquipmentOther: "",
    },
    validationSchema,

    onSubmit: (val) => {
      console.log("FORM VALUES 👉", val);

      const editing = isEdit;   // ✅ capture edit state

      const payload = {
        scheme: valueOrNull(val?.rusaPhase),
        compType: "3",
        compId: valueOrNull(val?.compId),
        constructionType: valueOrNull(val?.constructionType),
        subEquipId: valueOrNull(val?.subEquipId),
        otherWork: valueOrNull(val?.otherWork),
        subEquipmentOther: valueOrNull(val?.subEquipmentOther),
        equipmentOtherText: valueOrNull(val?.equipmentOtherText),
        noOfUnitsConstructed: valueOrNull(val?.noOfUnitsConstructed),
        progressOfWork: valueOrNull(val?.progressOfWork),
        startDate: valueOrNull(val?.startDate),
        dateOfCompletion: valueOrNull(val?.dateOfCompletion),
        percOfCompletion: valueOrNull(val?.percentageOfCompletion),
        status: valueOrNull(val?.presentStatus),
        constructionPhoto: valueOrNull(val?.geoTaggedPhotos),
        facilityUtilised: valueOrNull(val?.wetherUsing),
        briefDescription: valueOrNull(val?.briefDesc),
        videoLink: valueOrNull(val?.videoLinks),
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        conductedAt: '',
        activityStatus: '',
        noOfParticipate: '',
        uploadActivityReport: '',
      };
      console.log("dd", payload)
      // ✅ Dynamic API
      const apiUrl = editing
        ? `${config.url.API_URL}updateInfraWorks?sno=${editId}`
        : `${config.url.API_URL}saveRusaInfradtls`;

      // ✅ Dynamic confirmation text
      const confirmText = editing
        ? "Are you sure you want to update?"
        : "Are you sure you want to submit?";

      // ✅ Submit
      submitForm(
        payload,
        () => {
          console.log("✅ Submit success → refreshing data");

          // ✅ Always refresh after save & edit
          GetEquipData();

          formik.resetForm();
          setIsEdit(false);
          setEditId(null);
        },
        apiUrl,
        confirmText
      );
    }

  });
  const [component, setComponent] = useState([]);
  const [phasename, setPhasename] = useState([]);

  function GetComponentData(phase) {

    if (!phase) return;
    const url = `${config.url.API_URL}getRusaComponentList?rusa_phase=${phase}`;
    CommonAxiosGet(url).then((res) => {
      setComponent(res?.data?.scode === "01" ? res.data.data : []);
    });

  }
  function GetEquipScheme() {
    const url = `${config.url.API_URL}getPhase`;
    CommonAxiosGet(url).then((res) => {
      setPhasename(res?.data?.scode === "01" ? res.data.phase : []);
    });
  }




  const ReportColumns = [
    {
      id: "slNo",
      header: "Sl.No",
      cell: ({ row }) => row.index + 1,
    },

    {
      id: "scheme",
      header: "Scheme",
      accessorKey: "scheme",
    },

    {
      id: "comp_name",
      header: "Component Name",
      accessorKey: "comp_name",
      size: 1300, // adjust width in pixels
      cell: ({ row }) => {
        const Comp = row.original.comp_name;
        const otherWork = row.original.otherwork;
        return (
          <div style={{ minWidth: '250px', textAlign: "left" }}>
            {Comp && Comp.trim() !== "" ? Comp : otherWork}
          </div>
        );
      },
    },

    {
      id: "sub_comp_name_works",
      header: "Details Of Work",
      accessorKey: "sub_comp_name_works",

      cell: ({ row }) => {
        const Construction = row.original.construction_type;
        const otherWork = row.original.otherwork;
        const subcompname = row.original.sub_comp_name_works;

        return (
          <div className="text-start">
            {Construction === "99" ? otherWork : subcompname}
          </div>
        );
      },
    },



    {
      id: "no_of_units_constructed",
      header: "Number of Units / Nature of Work",
      accessorKey: "no_of_units_constructed",
    },
    {
      id: "progress_of_work",
      header: "Progress Of Work",
      accessorKey: "progress_of_work",
    },

    {
      id: "start_date",
      header: "Start Date",
      accessorKey: "start_date",
    },
    {
      id: "date_of_completion",
      header: "Date of Completion",
      accessorKey: "date_of_completion",
    },

    {
      id: "perc_of_completion",
      header: " Percentage of Completion",
      accessorKey: "perc_of_completion",
    },



    {
      id: "status",
      header: "Present Status",
      accessorKey: "status",
    },

    {
      id: "facility_utilised",
      header: "Whether Facility is in Use",
      accessorKey: "facility_utilised",
    },


    {
      id: "brief_description",
      header: "Brief description",
      accessorKey: "brief_description",
    },



    {
      id: "video_link",
      header: "Video Link",
      accessorKey: "video_link",
    },

    {
      id: "construction_photo",
      header: "Geo-Tagged Photo",
      accessorKey: "construction_photo",
      cell: ({ row }) => {
        const fileUrl = row.original?.construction_photo;

        if (!fileUrl) return null;

        return (
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="View File"
            onClick={() => viewImage(fileUrl)}
          >
            <BsEyeFill size={18} />
          </button>
        );
      },
    },
    /* ================= EDIT / DELETE ================= */
    // {
    //   id: "actions",
    //   header: "Edit / Delete",
    //   cell: ({ row }) => {
    //     const rowData = row.original;
    //     return (
    //       <div className="d-flex gap-2">
    //         <button
    //           type="button"
    //           className="btn btn-primary btn-sm"
    //           onClick={() => {
    //             GetSubWorksList(rowData?.construction_type);
    //             formik.setValues({
    //               rusaPhase: rowData?.scheme,
    //               constructionType: rowData?.construction_type,
    //               noOfUnitsConstructed: rowData?.no_of_units_constructed,
    //               progressOfWork: rowData?.progress_of_work,
    //               equipmentOtherText: rowData?.equipment_other_text,
    //               otherWork: rowData?.otherwork,
    //               compId: (rowData?.comp_id),
    //               startDate: rowData?.start_date,
    //               dateOfCompletion: rowData?.date_of_completion,
    //               percentageOfCompletion: rowData?.perc_of_completion,
    //               presentStatus: rowData?.status,
    //               subEquipId: rowData?.sub_equip_id,
    //               wetherUsing: rowData?.facility_utilised,
    //               briefDesc: rowData?.brief_description,
    //               geoTaggedPhotos: rowData?.construction_photo,
    //               videoLinks: rowData?.video_link,
    //               ...(rowData?.sub_equip_id === 999 && {
    //                 equipmentOtherText: rowData?.sub_equipment_other,
    //               }),
    //               ...(rowData?.construction_type === 99 && {
    //                 equipmentOtherText: rowData?.other_work,
    //               }),
    //             });
    //             GetComponentData(rowData?.scheme);
    //             setIsEdit(true);
    //             setEditId(rowData?.sno);
    //           }}
    //         >
    //           <FaEdit size={16} />
    //         </button>

    //         {/* 🗑️ DELETE */}
    //         <button
    //           type="button"
    //           className="btn btn-danger btn-sm"
    //           onClick={() => {
    //             Swal.fire({
    //               title: "Are you sure?",
    //               text: "Do you want to delete this record?",
    //               icon: "warning",
    //               showCancelButton: true,
    //               confirmButtonText: "Yes, delete it!",
    //             }).then((result) => {
    //               if (result.isConfirmed) {
    //                 const url = `${config.url.API_URL}deleteInfraWorks?sno=${rowData?.sno}`;

    //                 CommonAxiosPost(url)
    //                   .then((res) => {
    //                     if (res?.data?.scode === "01") {
    //                       Swal.fire(res?.data?.sdesc, "", "success");
    //                       GetEquipData();
    //                     } else {
    //                       Swal.fire("Delete failed", "", "error");
    //                     }
    //                   })

    //               }
    //             });
    //           }}
    //         >
    //           <RiDeleteBin2Line

    //             size={20} />
    //         </button>
    //       </div>
    //     );
    //   },
    // },




    {
      id: "actions",
      header: "Edit / Delete",
      cell: ({ row }) => {
        const rowData = row.original;

        return (
          <div className="d-flex gap-2">
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => {
                GetSubWorksList(rowData?.construction_type);

                formik.setValues({
                  rusaPhase: rowData?.scheme,
                  constructionType: rowData?.construction_type,
                  noOfUnitsConstructed: rowData?.no_of_units_constructed,
                  progressOfWork: rowData?.progress_of_work,
                  equipmentOtherText: rowData?.equipment_other_text,
                  otherWork: rowData?.otherwork,
                  compId: rowData?.comp_id,
                  startDate: rowData?.start_date,
                  dateOfCompletion: rowData?.date_of_completion,
                  percentageOfCompletion: rowData?.perc_of_completion,
                  presentStatus: rowData?.status,
                  subEquipId: rowData?.sub_equip_id,
                  wetherUsing: rowData?.facility_utilised,
                  briefDesc: rowData?.brief_description,
                  geoTaggedPhotos: rowData?.construction_photo,
                  videoLinks: rowData?.video_link,
                  ...(rowData?.sub_equip_id === 999 && {
                    equipmentOtherText: rowData?.sub_equipment_other,
                  }),
                  ...(rowData?.construction_type === 99 && {
                    equipmentOtherText: rowData?.other_work,
                  }),
                });

                GetComponentData(rowData?.scheme);
                setIsEdit(true);
                setEditId(rowData?.sno);
              }}
            >
              <FaEdit size={16} />
            </button>

            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={() => {
                console.log("DELETE BUTTON CLICKED");
                console.log("ROW DATA:", rowData);
                console.log("SNO:", rowData?.sno);

                deleteWithConfirm({
                  sno: rowData?.sno,
                  apiPath: "deleteInfraWorks",
                  onSuccess: GetEquipData,
                });
              }}
            >
              <RiDeleteBin2Line size={20} />
            </button>

          </div>
        );
      },
    }

  ];

  const [equipdata, setEquipdata] = useState([]);
  function GetEquipData() {
    let url = `${config.url.API_URL}getInfraWorksEquip?month=${currentMonth}&year=${currentYear}`;
    CommonAxiosGet(url).then((res) => {
      if (res?.data?.scode === "01" &&
        res?.data?.["equip"]?.length > 0) {
        setEquipdata(res.data["equip"]); // ✅ correct
      } else {
        setEquipdata([]);
      }
    });
  }

  useEffect(() => {
    GetEquipScheme();
    GetEquipData();
  }, [])
  const ongoingClearFields = [
    "startDate",
    "dateOfCompletion",
    "percentageOfCompletion",
    "presentStatus",
    "geoTaggedPhotos"

  ];

  const completedClearFields = [
    "startDate",
    "dateOfCompletion",
    "wetherUsing",
    "geoTaggedPhotos",
    "briefDesc",
    "videoLinks"

  ];
  return (
    <bie.Container fluid className="px-0">
      <bie.Container className="px-0 pt-3 mw-100 pb-5">
        <div className="overal-stathead">
          <span> Equipment</span></div>
        <FormikProvider value={formik}>
          <Form>
            <bie.Row className="g-3">
              <bie.Col lg={4}>
                <label>Scheme</label>
                <Field as="select" name="rusaPhase" className="form-control"
                  onChange={(e) => {
                    formik.handleChange(e);        // ✅ update Formik state
                    GetComponentData(e.target.value); // ✅ your custom logic
                  }}
                >
                  <option value="">--select--</option>
                  {phasename?.map((p) => (
                    <option key={p?.rusa_phase} value={p?.rusa_phase}>
                      {p?.rusa_phase}
                    </option>
                  ))}


                </Field>
                <ErrorMessage name="rusaPhase" component="div" className="text-danger" />

              </bie.Col>

              {/* Component */}
              <bie.Col lg={4}>
                <label>Component</label>
                <Field as="select" name="compId" className="form-control" >
                  <option value="">--select--</option>

                  {component?.map((c) => (
                    <option key={c?.comp_id} value={c?.comp_id}>
                      {c?.component_name}
                    </option>
                  ))}

                </Field>
                <ErrorMessage name="compId" component="div" className="text-danger" />

              </bie.Col>


              <WorkDetailsSelect
                works={worksList?.equi}
                label="List of Equipment"
                name="constructionType"
                onChange={(e) => {
                  formik?.setFieldValue("otherWork", "");
                  formik?.setFieldValue("subEquipmentOther", "");
                  formik?.setFieldValue("equipmentOtherText", "");
                  formik?.setFieldValue("subEquipId", "");



                  const selectedId = e.target.value;
                  formik?.setFieldValue("constructionType", selectedId);
                  GetSubWorksList(selectedId);
                }}
              />
              {formik?.values?.constructionType === "99" && <OtherWorkInput />}

              {["1", "2", "4"].includes(formik?.values?.constructionType) && (

                <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                  <label className="mb-1">
                    {formik?.values?.constructionType === "1"
                      ? "Digital Equipment"
                      : formik?.values?.constructionType === "2"
                        ? "Furniture"
                        : formik?.values?.constructionType === "4"
                          ? "Lab Equipment"
                          // : formik?.values?.constructionType === "5"
                          //   ? "Solar Equipment"
                          : ""}
                  </label>
                  <Field
                    as="select"
                    name="subEquipId"
                    className="form-control"
                    onChange={(e) => {
                      formik?.setFieldValue("subEquipmentOther", "");
                      formik?.handleChange(e);
                    }}
                  >
                    <option value="">-- Select --</option>
                    {subWorksList?.map((item) => (
                      <option key={item.sub_eq_id} value={item.sub_eq_id}>
                        {item.equipment_name}
                      </option>
                    ))}
                    <option value="999"> Others</option>

                  </Field>
                  <ErrorMessage name="subEquipId" component="div" className="text-danger" />
                </bie.Col>
              )}



              {["5", "3"].includes(formik?.values?.constructionType) && (
                <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                  <label className="mb-1"> Enter Eqiupment Name</label>
                  <Field name="equipmentOtherText" className="form-control" />
                  <ErrorMessage name="equipmentOtherText" component="div" className="text-danger" />
                </bie.Col>
              )}


              {formik?.values?.subEquipId === "999" &&
                (<bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                  <label className="mb-1">Enter Other Details</label>
                  <Field name="subEquipmentOther" className="form-control" />
                  <ErrorMessage
                    name="subEquipmentOther"
                    component="div"
                    className="text-danger"
                  />
                </bie.Col>
                )}

              <NoOfUnitsInput label="Number of Units" />

              {/* <ProgressSelect label="Status of Procurement" /> */}

              <ProgressSelect
                label="Status of Procurement"
                formik={formik}
                ongoingClearFields={ongoingClearFields}
                completedClearFields={completedClearFields}
              />

              {/* ONGOING */}
              {formik.values.progressOfWork === "ongoing" && (
                <>
                  <StartDateInput />
                  <EndDateInput />
                  <PercentageCompletionInput />
                  <PresentStatusInput />
                  <GeoTaggedPhotoInput name="geoTaggedPhotos" formik={formik} />
                </>
              )}

              {/* COMPLETED */}
              {formik.values.progressOfWork === "completed" && (
                <>
                  <FacilityInUseRadio />
                  <StartDateInput />

                  <EndDateInput />

                  {/* <BriefDescriptionInput /> */}
                  <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                    <label className="mb-1">
                      Brief description of Equipment (Details of equipment purchased, No. of Units, No. of Beneficiaries, etc.)
                    </label>
                    <Field as="textarea" name="briefDesc" className="form-control" />
                    <ErrorMessage name="briefDesc" component="div" className="text-danger" />
                  </bie.Col>

                  <GeoTaggedPhotoInput name="geoTaggedPhotos" formik={formik} />
                  <VideoLinkInput />
                </>
              )}
            </bie.Row>

            <div className="text-end mt-3">
              <button type="submit" className="btn btn-success">
                {isEdit ? "Update" : "Submit"}
              </button>
            </div>

            {equipdata?.length > 0 && (
              <>

                <div className="overal-stathead">
                  <span> Equipment Report</span></div>
                <div className="all-table-content">
                  <div className="table-responsive mt--40">
                    <CommonReactTable
                      data={equipdata}
                      columns={ReportColumns}
                      filename="Institute Wise Financial Report"
                      headerName="Institute Wise Financial Report"
                      showFooter={true}
                      showPagination={false}

                    />
                  </div>
                </div>
              </>
            )}
          </Form>
        </FormikProvider>
      </bie.Container>
    </bie.Container >
  );
};

export default Equipment;
